// assets/bridgens-laser-filestack-init.js
document.addEventListener('DOMContentLoaded', () => {
  // --- 1) Seleção de elementos ---
  const fileIn        = document.getElementById('file-input');
  const btnSelect     = document.getElementById('btn-select');
  const modal         = document.getElementById('crop-modal');
  const canvas        = document.getElementById('crop-canvas');
  const ctx           = canvas.getContext('2d');
  const btnZoomIn     = document.getElementById('btn-zoom-in');
  const btnZoomOut    = document.getElementById('btn-zoom-out');
  const btnRotL       = document.getElementById('btn-rot-left');
  const btnRotR       = document.getElementById('btn-rot-right');
  const rotationRange = document.getElementById('rotation-range');
  const btnSave       = document.getElementById('btn-crop-save');
  const btnCancel     = document.getElementById('btn-crop-cancel');
  const previewImg    = document.getElementById('diamond-image');
  const hiddenIn      = document.getElementById('filestack-url');

  if (!fileIn||!btnSelect||!modal||!canvas
      ||!btnZoomIn||!btnZoomOut||!btnRotL||!btnRotR
      ||!rotationRange||!btnSave||!btnCancel
      ||!previewImg||!hiddenIn) {
    console.warn('Faltando elemento, abortando crop JS.');
    return;
  }

  // --- 2) Estado interno ---
  let img       = new Image();
  let scale     = 1;
  let rotation  = 0;      // graus
  let offsetX   = 0;
  let offsetY   = 0;
  let dragging  = false;
  let startX    = 0;
  let startY    = 0;

  // --- 3) Função de desenho ---
  function draw() {
    const W = canvas.width;
    const H = canvas.height;
    ctx.clearRect(0,0,W,H);

    // clip em losango
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(W/2, 0);
    ctx.lineTo(W, H/2);
    ctx.lineTo(W/2, H);
    ctx.lineTo(0, H/2);
    ctx.closePath();
    ctx.clip();

    // transformações: move para centro+offset, rotaciona e escala
    ctx.translate(W/2 + offsetX, H/2 + offsetY);
    ctx.rotate(rotation * Math.PI/180);
    ctx.scale(scale, scale);
    ctx.translate(-img.width/2, -img.height/2);

    // filtro grayscale igual preview
    ctx.filter = 'grayscale(100%)';
    ctx.drawImage(img, 0, 0);

    ctx.restore();
  }

  // --- 4) Controles ---
  btnZoomIn.onclick  = () => { scale += 0.1; draw(); };
  btnZoomOut.onclick = () => { scale = Math.max(0.1, scale - 0.1); draw(); };

  btnRotL.onclick = () => {
    rotation = (rotation - 5 + 360) % 360;
    rotationRange.value = rotation;
    draw();
  };
  btnRotR.onclick = () => {
    rotation = (rotation + 5) % 360;
    rotationRange.value = rotation;
    draw();
  };

  rotationRange.oninput = e => {
    rotation = parseInt(e.target.value, 10);
    draw();
  };

  // --- 5) Dragging ---
  canvas.onmousedown = e => {
    dragging = true;
    startX   = e.clientX;
    startY   = e.clientY;
  };
  document.onmousemove = e => {
    if (!dragging) return;
    offsetX += e.clientX - startX;
    offsetY += e.clientY - startY;
    startX   = e.clientX;
    startY   = e.clientY;
    draw();
  };
  document.onmouseup = () => { dragging = false; };

  // --- 6) Selecionar arquivo e carregar imagem ---
  btnSelect.onclick = () => fileIn.click();
  fileIn.onchange   = e => {
    const file = e.target.files[0];
    if (!file) return;
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      // define tamanho do canvas (por ex, 300×300 ou recupere do mask DOM)
      const size = 600;
      canvas.width  = size;
      canvas.height = size;

      // reseta estado e desenha
      scale     = 1;
      rotation  = 0;
      offsetX   = 0;
      offsetY   = 0;
      rotationRange.value = 0;
      draw();
      modal.style.display = 'flex';
    };
  };

  // --- 7) Salvar & Upload ---
  btnSave.onclick = () => {
    canvas.toBlob(async blob => {
      try {
        const client    = filestack.init('AICGY73xCTGhWphQC7yu6z');
        const uploadRes = await client.upload(blob);
        hiddenIn.value  = uploadRes.url;
        previewImg.src  = URL.createObjectURL(blob);
      } catch(err) {
        console.error('Upload falhou', err);
        alert('Erro no upload, veja console.');
      } finally {
        modal.style.display = 'none';
      }
    }, 'image/png');
  };

  btnCancel.onclick = () => {
    modal.style.display = 'none';
  };
});
